import React from "react";
import { Affix } from "antd";
import { AffixProps } from "antd/lib/affix";

interface AffixComponentProps extends AffixProps {}

const AffixComponent = (props: AffixComponentProps) => {
  const {} = props;
  return <Affix {...props} />;
};

export default AffixComponent;
